export default function haveError(errors, field) {
  return errors && Object.prototype.hasOwnProperty.call(errors, field);
}
